<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text d-flex align-center justify-content-between">
        <v-tooltip color="white" v-if="contentJson?.lang?.[language]?.text || contentJson?.text" right content-class="tooltip-box-content" max-width="360" :open-delay="300" :close-delay="200" transition="slide-x-transition">
          <template v-slot:activator="{on, attrs}">
            <div v-bind="attrs" v-on="on" style="margin-right: -40px" class="text-uppercase">
              {{ $t("points-of-interest") }}
            </div>
          </template>
          <div v-html="contentJson?.lang?.[language]?.text || contentJson?.text"></div>
        </v-tooltip>
        <div v-else class="text-uppercase">
          {{ $t("points-of-interest") }}
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-text-field v-model="searchText" :label="$t('search-poi')" dense outlined clearable cprepend-inner-icon="mdi-magnify" @input="updateFieldsList" @click:clear="clearFieldsList" />
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <TooltipTR v-if="filteredFields.includes('ASSISTED_LIVING_NAME')" section="section1002" field="ASSISTED_LIVING_NAME" :label="$t('assisted_living_name')">
                <div>
                  <b>{{ $t("assisted_living_name") }}</b>
                </div>
                <div>{{ plotItem.ASSISTED_LIVING_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('ASSISTED_LIVING_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.ASSISTED_LIVING_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['ASSISTED_LIVING_DIST_KM_MORE']">&gt;</span>{{ plotItem.ASSISTED_LIVING_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.ASSISTED_LIVING_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['ASSISTED_LIVING_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.ASSISTED_LIVING_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.ASSISTED_LIVING_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['ASSISTED_LIVING_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.ASSISTED_LIVING_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.ASSISTED_LIVING_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['ASSISTED_LIVING_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.ASSISTED_LIVING_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('AUTOBAHN_NAME')" section="section1002" field="AUTOBAHN_NAME" :label="$t('autobahn_name')">
                <div>
                  <b>{{ $t("autobahn_name") }}</b>
                </div>
                <div>{{ plotItem.AUTOBAHN_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('AUTOBAHN_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.AUTOBAHN_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['AUTOBAHN_DIST_KM_MORE']">&gt;</span>{{ plotItem.AUTOBAHN_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.AUTOBAHN_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['AUTOBAHN_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.AUTOBAHN_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.AUTOBAHN_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['AUTOBAHN_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.AUTOBAHN_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.AUTOBAHN_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['AUTOBAHN_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.AUTOBAHN_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('CAMPINGPLATZ_NAME')" section="section1002" field="CAMPINGPLATZ_NAME" :label="$t('campingplatz_name')">
                <div>
                  <b>{{ $t("campingplatz_name") }}</b>
                </div>
                <div>{{ plotItem.CAMPINGPLATZ_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('CAMPINGPLATZ_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.CAMPINGPLATZ_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CAMPINGPLATZ_DIST_KM_MORE']">&gt;</span>{{ plotItem.CAMPINGPLATZ_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.CAMPINGPLATZ_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CAMPINGPLATZ_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.CAMPINGPLATZ_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.CAMPINGPLATZ_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CAMPINGPLATZ_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.CAMPINGPLATZ_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.CAMPINGPLATZ_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CAMPINGPLATZ_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.CAMPINGPLATZ_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('CLINIC_NAME')" section="section1002" field="CLINIC_NAME" :label="$t('clinic_name')">
                <div>
                  <b>{{ $t("clinic_name") }}</b>
                </div>
                <div>{{ plotItem.CLINIC_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('CLINIC_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.CLINIC_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CLINIC_DIST_KM_MORE']">&gt;</span>{{ plotItem.CLINIC_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.CLINIC_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CLINIC_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.CLINIC_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.CLINIC_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CLINIC_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.CLINIC_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.CLINIC_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['CLINIC_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.CLINIC_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('FLUGHAFEN_NAME')" section="section1002" field="FLUGHAFEN_NAME" :label="$t('flughafen_name')">
                <div>
                  <b>{{ $t("flughafen_name") }}</b>
                </div>
                <div>{{ plotItem.FLUGHAFEN_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('FLUGHAFEN_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.FLUGHAFEN_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUGHAFEN_DIST_KM_MORE']">&gt;</span>{{ plotItem.FLUGHAFEN_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FLUGHAFEN_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUGHAFEN_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.FLUGHAFEN_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FLUGHAFEN_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUGHAFEN_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.FLUGHAFEN_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FLUGHAFEN_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUGHAFEN_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.FLUGHAFEN_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('FLUSS_NAME')" section="section1002" field="FLUSS_NAME" :label="$t('fluss_name')">
                <div>
                  <b>{{ $t("fluss_name") }}</b>
                </div>
                <div>{{ plotItem.FLUSS_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('FLUSS_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.FLUSS_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUSS_DIST_KM_MORE']">&gt;</span>{{ plotItem.FLUSS_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FLUSS_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUSS_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.FLUSS_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FLUSS_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUSS_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.FLUSS_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FLUSS_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FLUSS_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.FLUSS_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('FRIEDHOF_NAME')" section="section1002" field="FRIEDHOF_NAME" :label="$t('friedhof_name')">
                <div>
                  <b>{{ $t("friedhof_name") }}</b>
                </div>
                <div>{{ plotItem.FRIEDHOF_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('FRIEDHOF_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.FRIEDHOF_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FRIEDHOF_DIST_KM_MORE']">&gt;</span>{{ plotItem.FRIEDHOF_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FRIEDHOF_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FRIEDHOF_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.FRIEDHOF_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FRIEDHOF_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FRIEDHOF_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.FRIEDHOF_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.FRIEDHOF_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['FRIEDHOF_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.FRIEDHOF_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('GEBIET_NAME')" section="section1002" field="GEBIET_NAME" :label="$t('gebiet_name')">
                <div>
                  <b>{{ $t("gebiet_name") }}</b>
                </div>
                <div>{{ plotItem.GEBIET_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('GEBIET_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.GEBIET_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GEBIET_DIST_KM_MORE']">&gt;</span>{{ plotItem.GEBIET_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.GEBIET_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GEBIET_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.GEBIET_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.GEBIET_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GEBIET_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.GEBIET_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.GEBIET_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GEBIET_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.GEBIET_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('GOLF_NAME')" section="section1002" field="GOLF_NAME" :label="$t('golf_name')">
                <div>
                  <b>{{ $t("golf_name") }}</b>
                </div>
                <div>{{ plotItem.GOLF_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('GOLF_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.GOLF_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GOLF_DIST_KM_MORE']">&gt;</span>{{ plotItem.GOLF_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.GOLF_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GOLF_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.GOLF_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.GOLF_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GOLF_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.GOLF_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.GOLF_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['GOLF_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.GOLF_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('HALTESTELLE_NAME')" section="section1002" field="HALTESTELLE_NAME" :label="$t('haltestelle_name')">
                <div>
                  <b>{{ $t("haltestelle_name") }}</b>
                </div>
                <div>{{ plotItem.HALTESTELLE_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('HALTESTELLE_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.HALTESTELLE_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_DIST_KM_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('HALTESTELLE_AUSSER_BETRIEB_NAME')" section="section1002" field="HALTESTELLE_AUSSER_BETRIEB_NAME" :label="$t('haltestelle_ausser_betrieb_name')">
                <div>
                  <b>{{ $t("haltestelle_ausser_betrieb_name") }}</b>
                </div>
                <div>{{ plotItem.HALTESTELLE_AUSSER_BETRIEB_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('HALTESTELLE_AUSSER_BETRIEB_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.HALTESTELLE_AUSSER_BETRIEB_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_AUSSER_BETRIEB_DIST_KM_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_AUSSER_BETRIEB_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_AUSSER_BETRIEB_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_AUSSER_BETRIEB_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_AUSSER_BETRIEB_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_AUSSER_BETRIEB_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_AUSSER_BETRIEB_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_AUSSER_BETRIEB_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_AUSSER_BETRIEB_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_AUSSER_BETRIEB_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_AUSSER_BETRIEB_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('HALTESTELLE_UND_BEDIENPUNKT_NAME')" section="section1002" field="HALTESTELLE_UND_BEDIENPUNKT_NAME" :label="$t('haltestelle_und_bedienpunkt_name')">
                <div>
                  <b>{{ $t("haltestelle_und_bedienpunkt_name") }}</b>
                </div>
                <div>{{ plotItem.HALTESTELLE_UND_BEDIENPUNKT_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('HALTESTELLE_UND_BEDIENPUNKT_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.HALTESTELLE_UND_BEDIENPUNKT_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_UND_BEDIENPUNKT_DIST_KM_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_UND_BEDIENPUNKT_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_UND_BEDIENPUNKT_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_UND_BEDIENPUNKT_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_UND_BEDIENPUNKT_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_UND_BEDIENPUNKT_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_UND_BEDIENPUNKT_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_UND_BEDIENPUNKT_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HALTESTELLE_UND_BEDIENPUNKT_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HALTESTELLE_UND_BEDIENPUNKT_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.HALTESTELLE_UND_BEDIENPUNKT_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('HOSPITAL_NAME')" section="section1002" field="HOSPITAL_NAME" :label="$t('hospital_name')">
                <div>
                  <b>{{ $t("hospital_name") }}</b>
                </div>
                <div>{{ plotItem.HOSPITAL_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('HOSPITAL_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.HOSPITAL_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HOSPITAL_DIST_KM_MORE']">&gt;</span>{{ plotItem.HOSPITAL_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HOSPITAL_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HOSPITAL_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.HOSPITAL_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HOSPITAL_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HOSPITAL_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.HOSPITAL_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.HOSPITAL_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['HOSPITAL_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.HOSPITAL_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('KINDERGARTEN_NAME')" section="section1002" field="KINDERGARTEN_NAME" :label="$t('kindergarten_name')">
                <div>
                  <b>{{ $t("kindergarten_name") }}</b>
                </div>
                <div>{{ plotItem.KINDERGARTEN_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('KINDERGARTEN_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.KINDERGARTEN_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KINDERGARTEN_DIST_KM_MORE']">&gt;</span>{{ plotItem.KINDERGARTEN_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.KINDERGARTEN_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KINDERGARTEN_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.KINDERGARTEN_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.KINDERGARTEN_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KINDERGARTEN_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.KINDERGARTEN_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.KINDERGARTEN_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KINDERGARTEN_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.KINDERGARTEN_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <TooltipTR v-if="filteredFields.includes('KIRCHE_NAME')" section="section1002" field="KIRCHE_NAME" :label="$t('kirche_name')">
                <div>
                  <b>{{ $t("kirche_name") }}</b>
                </div>
                <div>{{ plotItem.KIRCHE_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('KIRCHE_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.KIRCHE_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KIRCHE_DIST_KM_MORE']">&gt;</span>{{ plotItem.KIRCHE_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.KIRCHE_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KIRCHE_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.KIRCHE_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.KIRCHE_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KIRCHE_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.KIRCHE_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.KIRCHE_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['KIRCHE_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.KIRCHE_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>
              <!-- MARKET SECTION -->
              <TooltipTR v-if="filteredFields.includes('MARKET_NAME')" section="section1002" field="MARKET_NAME" :label="$t('market_name')">
                <div>
                  <b>{{ $t("market_name") }}</b>
                </div>
                <div>{{ plotItem.MARKET_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('MARKET_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.MARKET_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MARKET_DIST_KM_MORE']">&gt;</span>{{ plotItem.MARKET_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.MARKET_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MARKET_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.MARKET_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.MARKET_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MARKET_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.MARKET_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.MARKET_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MARKET_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.MARKET_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- MUSEUM SECTION -->
              <TooltipTR v-if="filteredFields.includes('MUSEUM_NAME')" section="section1002" field="MUSEUM_NAME" :label="$t('museum_name')">
                <div>
                  <b>{{ $t("museum_name") }}</b>
                </div>
                <div>{{ plotItem.MUSEUM_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('MUSEUM_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.MUSEUM_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MUSEUM_DIST_KM_MORE']">&gt;</span>{{ plotItem.MUSEUM_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.MUSEUM_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MUSEUM_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.MUSEUM_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.MUSEUM_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MUSEUM_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.MUSEUM_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.MUSEUM_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['MUSEUM_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.MUSEUM_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- NICHTCHRISTLICHER_KULTPLATZ SECTION -->
              <TooltipTR v-if="filteredFields.includes('NICHTCHRISTLICHER_KULTPLATZ_NAME')" section="section1002" field="NICHTCHRISTLICHER_KULTPLATZ_NAME" :label="$t('nichtchristlicher_kultplatz_name')">
                <div>
                  <b>{{ $t("nichtchristlicher_kultplatz_name") }}</b>
                </div>
                <div>{{ plotItem.NICHTCHRISTLICHER_KULTPLATZ_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('NICHTCHRISTLICHER_KULTPLATZ_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.NICHTCHRISTLICHER_KULTPLATZ_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['NICHTCHRISTLICHER_KULTPLATZ_DIST_KM_MORE']">&gt;</span>{{ plotItem.NICHTCHRISTLICHER_KULTPLATZ_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.NICHTCHRISTLICHER_KULTPLATZ_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['NICHTCHRISTLICHER_KULTPLATZ_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.NICHTCHRISTLICHER_KULTPLATZ_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.NICHTCHRISTLICHER_KULTPLATZ_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['NICHTCHRISTLICHER_KULTPLATZ_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.NICHTCHRISTLICHER_KULTPLATZ_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.NICHTCHRISTLICHER_KULTPLATZ_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['NICHTCHRISTLICHER_KULTPLATZ_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.NICHTCHRISTLICHER_KULTPLATZ_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- POLIZEI SECTION -->
              <TooltipTR v-if="filteredFields.includes('POLIZEI_NAME')" section="section1002" field="POLIZEI_NAME" :label="$t('polizei_name')">
                <div>
                  <b>{{ $t("polizei_name") }}</b>
                </div>
                <div>{{ plotItem.POLIZEI_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('POLIZEI_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.POLIZEI_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['POLIZEI_DIST_KM_MORE']">&gt;</span>{{ plotItem.POLIZEI_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.POLIZEI_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['POLIZEI_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.POLIZEI_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.POLIZEI_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['POLIZEI_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.POLIZEI_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.POLIZEI_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['POLIZEI_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.POLIZEI_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- REGIERUNGSSTELLE SECTION -->
              <TooltipTR v-if="filteredFields.includes('REGIERUNGSSTELLE_NAME')" section="section1002" field="REGIERUNGSSTELLE_NAME" :label="$t('regierungsstelle_name')">
                <div>
                  <b>{{ $t("regierungsstelle_name") }}</b>
                </div>
                <div>{{ plotItem.REGIERUNGSSTELLE_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('REGIERUNGSSTELLE_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.REGIERUNGSSTELLE_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['REGIERUNGSSTELLE_DIST_KM_MORE']">&gt;</span>{{ plotItem.REGIERUNGSSTELLE_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.REGIERUNGSSTELLE_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['REGIERUNGSSTELLE_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.REGIERUNGSSTELLE_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.REGIERUNGSSTELLE_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['REGIERUNGSSTELLE_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.REGIERUNGSSTELLE_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.REGIERUNGSSTELLE_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['REGIERUNGSSTELLE_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.REGIERUNGSSTELLE_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- SCHLOSS SECTION -->
              <TooltipTR v-if="filteredFields.includes('SCHLOSS_NAME')" section="section1002" field="SCHLOSS_NAME" :label="$t('schloss_name')">
                <div>
                  <b>{{ $t("schloss_name") }}</b>
                </div>
                <div>{{ plotItem.SCHLOSS_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('SCHLOSS_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.SCHLOSS_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHLOSS_DIST_KM_MORE']">&gt;</span>{{ plotItem.SCHLOSS_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SCHLOSS_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHLOSS_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.SCHLOSS_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SCHLOSS_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHLOSS_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.SCHLOSS_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SCHLOSS_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHLOSS_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.SCHLOSS_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- SCHULE SECTION -->
              <TooltipTR v-if="filteredFields.includes('SCHULE_NAME')" section="section1002" field="SCHULE_NAME" :label="$t('schule_name')">
                <div>
                  <b>{{ $t("schule_name") }}</b>
                </div>
                <div>{{ plotItem.SCHULE_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('SCHULE_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.SCHULE_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHULE_DIST_KM_MORE']">&gt;</span>{{ plotItem.SCHULE_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SCHULE_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHULE_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.SCHULE_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SCHULE_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHULE_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.SCHULE_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SCHULE_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SCHULE_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.SCHULE_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- SEE SECTION -->
              <TooltipTR v-if="filteredFields.includes('SEE_NAME')" section="section1002" field="SEE_NAME" :label="$t('see_name')">
                <div>
                  <b>{{ $t("see_name") }}</b>
                </div>
                <div>{{ plotItem.SEE_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('SEE_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.SEE_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SEE_DIST_KM_MORE']">&gt;</span>{{ plotItem.SEE_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SEE_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SEE_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.SEE_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SEE_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SEE_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.SEE_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SEE_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SEE_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.SEE_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- SPITAL SECTION -->
              <TooltipTR v-if="filteredFields.includes('SPITAL_NAME')" section="section1002" field="SPITAL_NAME" :label="$t('spital_name')">
                <div>
                  <b>{{ $t("spital_name") }}</b>
                </div>
                <div>{{ plotItem.SPITAL_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('SPITAL_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.SPITAL_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SPITAL_DIST_KM_MORE']">&gt;</span>{{ plotItem.SPITAL_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SPITAL_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SPITAL_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.SPITAL_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SPITAL_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SPITAL_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.SPITAL_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.SPITAL_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['SPITAL_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.SPITAL_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- STADION SECTION -->
              <TooltipTR v-if="filteredFields.includes('STADION_NAME')" section="section1002" field="STADION_NAME" :label="$t('stadion_name')">
                <div>
                  <b>{{ $t("stadion_name") }}</b>
                </div>
                <div>{{ plotItem.STADION_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('STADION_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.STADION_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['STADION_DIST_KM_MORE']">&gt;</span>{{ plotItem.STADION_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.STADION_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['STADION_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.STADION_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.STADION_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['STADION_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.STADION_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.STADION_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['STADION_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.STADION_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>
              <!-- THERMALBAD SECTION -->
              <TooltipTR v-if="filteredFields.includes('THERMALBAD_NAME')" section="section1002" field="THERMALBAD_NAME" :label="$t('thermalbad_name')">
                <div>
                  <b>{{ $t("thermalbad_name") }}</b>
                </div>
                <div>{{ plotItem.THERMALBAD_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('THERMALBAD_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.THERMALBAD_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['THERMALBAD_DIST_KM_MORE']">&gt;</span>{{ plotItem.THERMALBAD_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.THERMALBAD_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['THERMALBAD_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.THERMALBAD_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.THERMALBAD_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['THERMALBAD_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.THERMALBAD_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.THERMALBAD_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['THERMALBAD_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.THERMALBAD_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>

              <!-- UNIVERSITY SECTION -->
              <TooltipTR v-if="filteredFields.includes('UNIVERSITY_NAME')" section="section1002" field="UNIVERSITY_NAME" :label="$t('university_name')">
                <div>
                  <b>{{ $t("university_name") }}</b>
                </div>
                <div>{{ plotItem.UNIVERSITY_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('UNIVERSITY_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.UNIVERSITY_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['UNIVERSITY_DIST_KM_MORE']">&gt;</span>{{ plotItem.UNIVERSITY_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.UNIVERSITY_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['UNIVERSITY_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.UNIVERSITY_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.UNIVERSITY_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['UNIVERSITY_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.UNIVERSITY_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.UNIVERSITY_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['UNIVERSITY_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.UNIVERSITY_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>
              <TooltipTR v-if="filteredFields.includes('VERGNUEGUNGSPARK_NAME')" section="section1002" field="VERGNUEGUNGSPARK_NAME" :label="$t('vergnuegungspark_name')">
                <div>
                  <b>{{ $t("vergnuegungspark_name") }}</b>
                </div>
                <div>{{ plotItem.VERGNUEGUNGSPARK_NAME }}</div>
              </TooltipTR>
              <tr v-if="filteredFields.includes('VERGNUEGUNGSPARK_NAME')">
                <td colspan="2" style="padding-left: 2em; padding-top: 8px; padding-bottom: 18px; border: 0 none">
                  <div class="d-flex flex-wrap" style="gap: 4px">
                    <v-chip v-if="plotItem.VERGNUEGUNGSPARK_DIST_KM != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-map-marker-distance</v-icon>
                      {{ $t("dist_km") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['VERGNUEGUNGSPARK_DIST_KM_MORE']">&gt;</span>{{ plotItem.VERGNUEGUNGSPARK_DIST_KM }} km</span>
                    </v-chip>
                    <v-chip v-if="plotItem.VERGNUEGUNGSPARK_TIME_CAR_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-car</v-icon>
                      {{ $t("time_car_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['VERGNUEGUNGSPARK_TIME_CAR_MIN_MORE']">&gt;</span>{{ plotItem.VERGNUEGUNGSPARK_TIME_CAR_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.VERGNUEGUNGSPARK_TIME_WALK_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-walk</v-icon>
                      {{ $t("time_walk_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['VERGNUEGUNGSPARK_TIME_WALK_MIN_MORE']">&gt;</span>{{ plotItem.VERGNUEGUNGSPARK_TIME_WALK_MIN | smartTime }} min</span>
                    </v-chip>
                    <v-chip v-if="plotItem.VERGNUEGUNGSPARK_TIME_BIKE_MIN != null" small outlined label color="grey darken-2">
                      <v-icon left small>mdi-bicycle</v-icon>
                      {{ $t("time_bike_min") }}: <span class="font-weight-bold ml-1"><span v-if="plotItem['VERGNUEGUNGSPARK_TIME_BIKE_MIN_MORE']">&gt;</span>{{ plotItem.VERGNUEGUNGSPARK_TIME_BIKE_MIN | smartTime }} min</span>
                    </v-chip>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import TooltipTR from "./TooltipText.vue"

@Component({
  components: {TooltipTR},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem

  contentJson: any = {}
  language

  searchText = ""

  fieldsMulti: any = {
    langs: {
      en: [
        {label: "Assisted Living", key: "ASSISTED_LIVING_NAME"},
        {label: "Highway", key: "AUTOBAHN_NAME"},
        {label: "Campground", key: "CAMPINGPLATZ_NAME"},
        {label: "Clinic", key: "CLINIC_NAME"},
        {label: "Airport", key: "FLUGHAFEN_NAME"},
        {label: "River", key: "FLUSS_NAME"},
        {label: "Cemetery", key: "FRIEDHOF_NAME"},
        {label: "Area", key: "GEBIET_NAME"},
        {label: "Golf Course", key: "GOLF_NAME"},
        {label: "Stop", key: "HALTESTELLE_NAME"},
        {label: "Out of Service Stop", key: "HALTESTELLE_AUSSER_BETRIEB_NAME"},
        {label: "Stop and Service Point", key: "HALTESTELLE_UND_BEDIENPUNKT_NAME"},
        {label: "Hospital", key: "HOSPITAL_NAME"},
        {label: "Kindergarten / Nursery", key: "KINDERGARTEN_NAME"},
        {label: "Church", key: "KIRCHE_NAME"},
        {label: "Market", key: "MARKET_NAME"},
        {label: "Museum", key: "MUSEUM_NAME"},
        {label: "Non-Christian Place of Worship", key: "NICHTCHRISTLICHER_KULTPLATZ_NAME"},
        {label: "Police Station", key: "POLIZEI_NAME"},
        {label: "Government Office", key: "REGIERUNGSSTELLE_NAME"},
        {label: "Castle", key: "SCHLOSS_NAME"},
        {label: "School", key: "SCHULE_NAME"},
        {label: "Lake", key: "SEE_NAME"},
        {label: "Clinic/Hospital", key: "SPITAL_NAME"},
        {label: "Stadium", key: "STADION_NAME"},
        {label: "Thermal Bath / Spa", key: "THERMALBAD_NAME"},
        {label: "University", key: "UNIVERSITY_NAME"},
        {label: "Amusement Park", key: "VERGNUEGUNGSPARK_NAME"},
      ],
      de: [
        {label: "Betreutes Wohnen", key: "ASSISTED_LIVING_NAME"},
        {label: "Autobahn", key: "AUTOBAHN_NAME"},
        {label: "Campingplatz", key: "CAMPINGPLATZ_NAME"},
        {label: "Klinik", key: "CLINIC_NAME"},
        {label: "Flughafen", key: "FLUGHAFEN_NAME"},
        {label: "Fluss", key: "FLUSS_NAME"},
        {label: "Friedhof", key: "FRIEDHOF_NAME"},
        {label: "Gebiet", key: "GEBIET_NAME"},
        {label: "Golfplatz", key: "GOLF_NAME"},
        {label: "Haltestelle", key: "HALTESTELLE_NAME"},
        {label: "Haltestelle außer Betrieb", key: "HALTESTELLE_AUSSER_BETRIEB_NAME"},
        {label: "Haltestelle und Bedienpunkt", key: "HALTESTELLE_UND_BEDIENPUNKT_NAME"},
        {label: "Krankenhaus", key: "HOSPITAL_NAME"},
        {label: "Kindergarten", key: "KINDERGARTEN_NAME"},
        {label: "Kirche", key: "KIRCHE_NAME"},
        {label: "Einkaufsmöglichkeit", key: "MARKET_NAME"},
        {label: "Museum", key: "MUSEUM_NAME"},
        {label: "Nichtchristlicher Kultplatz", key: "NICHTCHRISTLICHER_KULTPLATZ_NAME"},
        {label: "Polizeistation", key: "POLIZEI_NAME"},
        {label: "Regierungsstelle", key: "REGIERUNGSSTELLE_NAME"},
        {label: "Schloss", key: "SCHLOSS_NAME"},
        {label: "Schule", key: "SCHULE_NAME"},
        {label: "See", key: "SEE_NAME"},
        {label: "Spital", key: "SPITAL_NAME"},
        {label: "Stadion", key: "STADION_NAME"},
        {label: "Thermalbad", key: "THERMALBAD_NAME"},
        {label: "Universität", key: "UNIVERSITY_NAME"},
        {label: "Vergnügungspark", key: "VERGNUEGUNGSPARK_NAME"},
      ],
      it: [
        {label: "Residenza assistita", key: "ASSISTED_LIVING_NAME"},
        {label: "Autostrada", key: "AUTOBAHN_NAME"},
        {label: "Campeggio", key: "CAMPINGPLATZ_NAME"},
        {label: "Clinica", key: "CLINIC_NAME"},
        {label: "Aeroporto", key: "FLUGHAFEN_NAME"},
        {label: "Fiume", key: "FLUSS_NAME"},
        {label: "Cimitero", key: "FRIEDHOF_NAME"},
        {label: "Area", key: "GEBIET_NAME"},
        {label: "Campo da golf", key: "GOLF_NAME"},
        {label: "Fermata", key: "HALTESTELLE_NAME"},
        {label: "Fermata fuori servizio", key: "HALTESTELLE_AUSSER_BETRIEB_NAME"},
        {label: "Fermata e punto di servizio", key: "HALTESTELLE_UND_BEDIENPUNKT_NAME"},
        {label: "Ospedale", key: "HOSPITAL_NAME"},
        {label: "Asilo", key: "KINDERGARTEN_NAME"},
        {label: "Chiesa", key: "KIRCHE_NAME"},
        {label: "Mercato", key: "MARKET_NAME"},
        {label: "Museo", key: "MUSEUM_NAME"},
        {label: "Luogo di culto non cristiano", key: "NICHTCHRISTLICHER_KULTPLATZ_NAME"},
        {label: "Stazione di polizia", key: "POLIZEI_NAME"},
        {label: "Ufficio governativo", key: "REGIERUNGSSTELLE_NAME"},
        {label: "Castello", key: "SCHLOSS_NAME"},
        {label: "Scuola", key: "SCHULE_NAME"},
        {label: "Lago", key: "SEE_NAME"},
        {label: "Clinica/Ospedale", key: "SPITAL_NAME"},
        {label: "Stadio", key: "STADION_NAME"},
        {label: "Terme", key: "THERMALBAD_NAME"},
        {label: "Università", key: "UNIVERSITY_NAME"},
        {label: "Parco divertimenti", key: "VERGNUEGUNGSPARK_NAME"},
      ],
      fr: [
        {label: "Résidence assistée", key: "ASSISTED_LIVING_NAME"},
        {label: "Autoroute", key: "AUTOBAHN_NAME"},
        {label: "Camping", key: "CAMPINGPLATZ_NAME"},
        {label: "Clinique", key: "CLINIC_NAME"},
        {label: "Aéroport", key: "FLUGHAFEN_NAME"},
        {label: "Rivière", key: "FLUSS_NAME"},
        {label: "Cimetière", key: "FRIEDHOF_NAME"},
        {label: "Zone", key: "GEBIET_NAME"},
        {label: "Terrain de golf", key: "GOLF_NAME"},
        {label: "Arrêt", key: "HALTESTELLE_NAME"},
        {label: "Arrêt hors service", key: "HALTESTELLE_AUSSER_BETRIEB_NAME"},
        {label: "Arrêt et point de service", key: "HALTESTELLE_UND_BEDIENPUNKT_NAME"},
        {label: "Hôpital", key: "HOSPITAL_NAME"},
        {label: "Jardin d'enfants", key: "KINDERGARTEN_NAME"},
        {label: "Église", key: "KIRCHE_NAME"},
        {label: "Marché", key: "MARKET_NAME"},
        {label: "Musée", key: "MUSEUM_NAME"},
        {label: "Lieu de culte non chrétien", key: "NICHTCHRISTLICHER_KULTPLATZ_NAME"},
        {label: "Poste de police", key: "POLIZEI_NAME"},
        {label: "Bureau gouvernemental", key: "REGIERUNGSSTELLE_NAME"},
        {label: "Château", key: "SCHLOSS_NAME"},
        {label: "École", key: "SCHULE_NAME"},
        {label: "Lac", key: "SEE_NAME"},
        {label: "Clinique/Hôpital", key: "SPITAL_NAME"},
        {label: "Stade", key: "STADION_NAME"},
        {label: "Bain thermal", key: "THERMALBAD_NAME"},
        {label: "Université", key: "UNIVERSITY_NAME"},
        {label: "Parc d'attractions", key: "VERGNUEGUNGSPARK_NAME"},
      ],
    },
  }

  fields = ["ASSISTED_LIVING_NAME", "AUTOBAHN_NAME", "CAMPINGPLATZ_NAME", "CLINIC_NAME", "FLUGHAFEN_NAME", "FLUSS_NAME", "FRIEDHOF_NAME", "GEBIET_NAME", "GOLF_NAME", "HALTESTELLE_NAME", "HALTESTELLE_AUSSER_BETRIEB_NAME", "HALTESTELLE_UND_BEDIENPUNKT_NAME", "HOSPITAL_NAME", "KINDERGARTEN_NAME", "KIRCHE_NAME", "MARKET_NAME", "MUSEUM_NAME", "NICHTCHRISTLICHER_KULTPLATZ_NAME", "POLIZEI_NAME", "REGIERUNGSSTELLE_NAME", "SCHLOSS_NAME", "SCHULE_NAME", "SEE_NAME", "SPITAL_NAME", "STADION_NAME", "THERMALBAD_NAME", "UNIVERSITY_NAME", "VERGNUEGUNGSPARK_NAME"]
  filteredFields: any = []
  fieldsLang: any = []

  created() {
    this.language = localStorage.getItem("user-language") || "en"
    this.fieldsLang = this.fieldsMulti.langs[this.language]
    this.loadTooltip()
    this.filteredFields = this.fields
  }

  clearFieldsList() {
    this.filteredFields = this.fields
  }

  updateFieldsList() {
    let tmp = this.fieldsLang.filter((fieldObj) => {
      let label = fieldObj.label
      let key = fieldObj.key
      let isOk = label.toLowerCase().includes(this.searchText.toLowerCase())
      if (isOk) {
        return key
      } else {
        return null
      }
    })

    this.filteredFields = tmp.map((fieldObj) => fieldObj.key)
  }

  async loadTooltip() {
    this.contentJson = (await this.$store.dispatch("tooltip/getTooltipContent", "section1001")) || {}
  }
}
</script>
